module.exports = __webpack_public_path__ + "media/images/icons/filled/file-zip-718dcad1fccbcf2d920215339445f40d.svg";